export default __webpack_public_path__ + "static/18_30-4c6a6882c5b4a34625288a8400b612aa.png";